module.exports = __webpack_public_path__ + "static/media/Wheelchair.86a1fa14.svg";